module.exports = __webpack_public_path__ + "img/werknemers-icon.a677495.png";